import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ResetPasswordPage.css';

const RequestPasswordResetPage = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    setSuccess('');
    try {
      const response = await axios.post('/api/auth/request-password-reset', { 
        email: email.toLowerCase().trim() 
      });
      if (response.data.success) {
        setSuccess('If the email exists, a password reset link has been sent. Please check your inbox.');
      } else {
        setError(response.data.message || 'Failed to send reset email.');
      }
    } catch (err) {
      if (err.response?.status === 429) {
        setError('You can only request a reset email once per minute. Please try again later.');
      } else {
        setError(err.response?.data?.message || 'Failed to send reset email.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-password-outer">
      <div className="reset-password-page">
        <div className="reset-password-container">
          {/* Header */}
          <div className="reset-password-header">
            <div className="reset-password-logo" style={{ background: 'none', boxShadow: 'none', color: 'inherit', cursor: 'pointer' }} onClick={() => navigate('/login')}>
              <img src="/logo-black.png" alt="VegaX Logo" style={{ width: 104, height: 104, display: 'block', objectFit: 'contain' }} />
            </div>
            <h1 className="reset-password-title">Request Password Reset</h1>
            <p className="reset-password-subtitle">Enter your email to receive a password reset link</p>
          </div>

          {/* Form */}
          <div className="reset-password-form-container">
            <form onSubmit={handleSubmit} className="reset-password-form">
              {error && <div className="error-alert"><span>⚠️</span>{error}</div>}
              {success && <div className="success-alert"><span>✅</span>{success}</div>}
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  className="form-input"
                  required
                />
              </div>
              <button type="submit" className="reset-password-button" disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Send Reset Email'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequestPasswordResetPage; 